import * as $ from 'jquery';
import * as Cookies from 'js-cookie';
export class instantSearch{ 

	instantSearchApi(): any{
		let $orginLocation:any   		= $('#instantSearchOrigin').val();
		let $destinationLocation:any    = $('#instantSearchLocation').val();
		let $countrySite:any   			= $('#instantSearchCountrySite').val();
		let $siteLang:any               = Cookies.get('session-selected-language');	
		if($siteLang){
			if($siteLang == 'en' ){
				$siteLang      = 'gb';
			}else if ($siteLang == 'zh_CN' || $siteLang =='zh_HK'){
				$siteLang  = 'cn';
			}
		}else{
			$siteLang ='gb';
		}

	//https://pcm.ap5.amadeus.com
	//	"https://fly.malaysiaairlines.com/V0/airPromotions?siteCode=J03UJ03U&languageCode=GB&countrySite=AU&nbResults=2&contentCodes=all"
		$.ajax({
			url: "https://fly.malaysiaairlines.com/V0/airPromotions?siteCode=J03UJ03U&languageCode="+$siteLang+"&countrySite="+$countrySite+"&originLocationCode="+$orginLocation+"&originLocationType=location&destinationLocationCode="+$destinationLocation+"&destinationLocationType=location&contentCodes=information,teaser2",
		   success: function(data:any) {
			   var htmlContents = data.data.airPromotions[0].htmlContents;
			   for (let contentKey in htmlContents) {
				   var templateInstantSearch = htmlContents[contentKey];
				   var templateInstantSearchRes = templateInstantSearch.replace("https://maxcdn.bootstrapcdn.com/bootstrap/3.3.5/css/bootstrap.min.css", "");
				   $("#responseHtml").append(templateInstantSearchRes);  
			   }
		   },
		   error: function(error:any) {
   
	   },
		   cache: false,
		   contentType: false,
		   processData: false,
	   });
	}
}
let scope:Element = document.querySelector('#instant-search');
if (scope){
	try {
		let instantSearchObj = new instantSearch();
		instantSearchObj.instantSearchApi();
	} catch(e) {console.error(e);}
}